import {getLoginUser,
  loginOut,
  getMdOpenFuncs,
  getDocSignConfig,
  getPowerList,
  getAccountConfigByCond,
  queryUserActSignInfo,
  validMetorFlaginActIds, apiNoauthTenantConfig} from '@/assets/js/api';

import {getLoginUrl} from '@/assets/js/server.js';
import {cache_crrentActId} from '@/assets/js/constant';
import Vue from 'vue';

export default {
  state: {
    // 用户信息
    userData: {},
    // 机构列表
    accountList: [],
    // 角色列表
    roleMaps: {},
    // 开通功能
    openFuns: [],
    userFunPermissions: [],
    // 开通文书类型
    openDocType: [],
    // 开通案由类型
    openCauseType: [],
    // 分案模式
    actDiviMode: '',
    // 当前机构
    actId: '',
    actLevel: '',
    // 是否开通作业平台
    callCenter: false,
    // 保融通机构id
    brtActId: '', // 36b8ede7328c4cafb65343d0d0406444
    activeRole: '',
    grayTest: [],
    brtGrayTest: [],

    /**
     CASE_ADMIN("case_admin", "案件管理员"),
     MEDIATOR("mediator", "调解员"),
     AGENT("agent", "代理人"),
     ORG_ADMIN("org_admin", "机构管理员"),
     OPERATION("operation", "运营"),
     */
    activeRoleName: '',

    currentActId: '', // 当前选中机构
    /**
     PLAINTIFF("1", "申请人"),
     DEFENDANT("2", "被申请人"),
     PLAINTIFF_AGENT("3", "申请人代理人"),
     DEFENDANT_AGENT("4", "被申请人代理人"),
     MEDIATOR("5", "调解员")
     */
    docSignConfig: {}, // key=actId，value=array
    // 是否是超管用户
    isAdminUser: false,
    userPower: [],
    // 文书签约权限
    wsqzPower: 1,
    // 逐级分案-当前机构直接子机构
    subOrgList: {},
    // 逐级分案-当前机构下的调解员列表
    // orgMediatorList: {},
    // 当前页面加载状态，即getLoginUser是否已经调用成功了
    projectLoadState: 'create',
    userActSignInfo: {
      mdtorSignStrategy: '',
      fillIdNumFlag: '',
      corpAdminName: ''
    },
    // 当前机构及所在机构树是否有调解员角色
    isHaveMediatorValid: false,
    // 金融机构 mediationOrgans 映射: { [finActId]: [{v3Enabled, ...}] }
    mediationOrgansMap: {}
  },
  getters: {
    actTips: state => {
      let result = '';
      for (let i = 0; i < state.accountList.length; i++) {
        if (state.accountList[i].actId === state.actId) {
          result = state.accountList[i].actTips;
          break;
        }
      }
      return result;
    },
    // 用户信息
    firstName: state => {
      if (state.userData.name) {
        return state.userData.name.substr(0, 1);
      }
      return '';
    },
    // 角色列表
    roleList: state => state.roleMaps[state.actId],
    docSignCfg: state => state.docSignConfig[state.actId] || {},
    // 获取当前激活的角色标识
    activeRoleCode: state => {
      switch (state.activeRoleName) {
        case '案件管理员':
          return 'case_admin';
        case '调解员':
          return 'mediator';
        case '代理人':
          return 'agent';
        case '机构管理员':
          return 'org_admin';
        case '运营':
          return 'operation';
        default:
          return state.isAdminUser ? 'operation' : '';
      }
    },
    // 是否灰度
    openGray: state => {
      const {
        grayTest, brtGrayTest, actId, brtActId
      } = state;
      if (brtActId) {
        if (brtGrayTest.length) {
          return !brtGrayTest.includes(brtActId);
        } else {
          return false;
        }
      } else if (grayTest.length) {
        return !grayTest.includes(actId);
      } else {
        return false;
      }
    },
    // 当前金融机构下所有调解机构是否均为 v3Enabled
    isAllV3Enabled: state => (finActId) => {
      const organs = state.mediationOrgansMap[finActId] || [];
      if (organs.length === 0) return false;
      return organs.every(org => org.v3Enabled === true);
    },
    // 返回当前金融机构下所有 v3Enabled 调解机构的 ID 集合
    v3OrganIds: state => (finActId) => {
      const organs = state.mediationOrgansMap[finActId] || [];
      return organs
        .filter(org => org.v3Enabled === true)
        .map(org => org.cbh || org.actId)
        .filter(Boolean);
    }
  },
  mutations: {
    SET_USERDATA: (state, userData) => {
      state.userData = userData.user || {};
      // 放在window上，用于server.js使用
      window._userId = state.userData.id || '';
      state.accountList = userData.accountList || [];
      state.roleMaps = userData.roleMaps || {};
      state.isAdminUser = userData.adminUser || false;
      if (!userData.accountList.length) {
        return;
      }
      // 如果当前actId不存在或者和所有机构编号不一致，则重新获取当前机构编号
      if (!state.actId || state.accountList.every(item => state.actId !== item.actId)) {
        state.actId = state.accountList[0].actId;
        state.actLevel = state.accountList[0].actLevel;
        state.activeRole = state.roleMaps[state.actId][0].id;
        state.activeRoleName = state.roleMaps[state.actId][0].name;
        //
      } else if (!state.activeRole || state.roleMaps[state.actId].every(item => item.id !== state.activeRole)) {
        state.activeRole = state.roleMaps[state.actId][0].id;
        state.activeRoleName = state.roleMaps[state.actId][0].name;
      }
      sessionStorage.setItem(cache_crrentActId, state.actId);
    },
    CHANGE_ORGAN: (state, data) => {
      if (state.actId === data.actId) {
        return;
      }
      const coleMap = state.roleMaps[data.actId];
      state.actId = data.actId;
      if (coleMap) {
        const sameRole = coleMap.filter(item => item.name === state.activeRoleName);
        state.actLevel = data.actLevel;
        state.activeRole = sameRole.length > 0 ? sameRole[0].id : coleMap[0].id;
        state.activeRoleName = sameRole.length > 0 ? sameRole[0].name : coleMap[0].name;
        sessionStorage.setItem(cache_crrentActId, state.actId);
      }
    },
    CHANGE_ROLE: (state, data) => {
      if (state.activeRole === data.id) {
        return;
      }
      state.activeRole = data.id;
      state.activeRoleName = data.name;
    },
    SYNC_DOC_SIGN_CFG: (state, data) => {
      Vue.set(state.docSignConfig, state.actId, data);
    },
    SET_CURRENTACTID: (state, data) => {
      state.currentActId = data;
    },
    SAVE_BRT_ID: (state, data) => {
      state.brtActId = data;
    },
    // 设置文书类型和开通功能
    SET_OPEN_INFO: (state, data) => {
      // 开通文书类型
      state.openDocType = data.openDocType && data.openDocType.split(',') || [];
      state.openCauseType = data.openCauseType && data.openCauseType.split(',') || [];
      // 开通功能
      state.openFuns = data.openFuns && data.openFuns.split(',') || [];
      // 分案模式
      state.actDiviMode = data.actDiviMode ? data.actDiviMode.toString() : '3';
      state.userFunPermissions = data.userFunPermissions || [];
    },
    SET_USER_POWER: (state, data) => {
      state.userPower = data;
    },
    SET_WSQZ_POWER: (state, data) => {
      // 1 无权限
      // 2 有权限有案件
      // 3 有权限无案件
      state.wsqzPower = data.selfSign;
    },
    // 设置当前机构直接子机构
    SET_SUB_ORGAN_LIST: (state, data) => {
      state.subOrgList[data.actId] = data.list;
    },
    // 设置当前机构调解员列表
    // SET_ORGAN_MEDIATOR_LIST: (state, data) => {
    //   state.orgMediatorList[data.actId] = data.list;
    // },
    // 设置当前机构的分案模式
    SET_ACT_DIVI_MODE: (state, data) => {
      state.actDiviMode = data.toString() || '3';
    },
    // 设置项目加载状态
    SET_PROJECT_LOAD_STATE: (state, data) => {
      state.projectLoadState = data;
    },
    SET_USER_ACT_SIGN_INFO: (state, data) => {
      Object.assign(state.userActSignInfo, data);
    },
    SET_GRAY_TEST: (state, {
      grayTest, brtGrayTest
    }) => {
      if (typeof grayTest === 'object' && !Array.isArray(grayTest)) {
        state.grayTest = Object.values(grayTest);
      }
      if (typeof brtGrayTest === 'object' && !Array.isArray(brtGrayTest)) {
        state.brtGrayTest = Object.values(brtGrayTest);
      }
    },
    SET_VALID_MEDIATOR_FLAG: (state, data) => {
      state.isHaveMediatorValid = data;
    },
    SET_MEDIATION_ORGANS: (state, actList) => {
      const map = {};
      (actList || []).forEach(finOrg => {
        if (finOrg && finOrg.actId) {
          map[finOrg.actId] = finOrg.mediationOrgans || [];
        }
      });
      state.mediationOrgansMap = map;
    },
    SET_CALL_CENTER: (state, data) => {
      state.callCenter = data;
    },
  },
  actions: {
    // 本地登录
    Login({commit}) {
      return new Promise((resolve, reject) => {
        getLoginUser()
          .then(response => {
            if (response && response.code === 200) {
              commit('SET_USERDATA', response.data);
              // 当前页面加载完成
              commit('SET_PROJECT_LOAD_STATE', 'ready');
              resolve(response);
            } else {
              // 当前页面加载完成
              commit('SET_PROJECT_LOAD_STATE', 'fail');
              reject(response);
            }
          })
          .catch(error => {
            commit('SET_PROJECT_LOAD_STATE', 'fail');
            reject(error);
          });
      });
    },
    // 登出
    LoginOut() {
      sessionStorage.clear();
      // 获取当前登录地址，可以直接跳转到登录页，而不用再刷新一下页面了
      const loginUrl = getLoginUrl();
      window.location.href = loginOut + window.encodeURIComponent(loginUrl);
    },
    // 切换机构
    ChangeOrgan({commit}, data) {
      commit('CHANGE_ORGAN', data);
    },
    // 切换角色
    ChangeRole({commit}, data) {
      commit('CHANGE_ROLE', data);
    },
    // 获取机构下的文书签字配置
    SyncDocSignCfg({
      commit, state
    }, actId) {
      return new Promise((resolve, reject) => {
        if (!state.actId && !actId) {
          return;
        }
        getDocSignConfig({actId: state.actId || actId})
          .then(response => {
            if (response && response.code === 200) {
              console.log('getDocSignConfigByActId', response.data);
              commit('SYNC_DOC_SIGN_CFG', response.data);
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SaveBrtId({commit}, data) {
      commit('SAVE_BRT_ID', data);
    },
    // 获取当前用户的开通功能和文书类型
    getMdOpenFuncs({
      commit, state
    }, actId) {
      return new Promise((resolve, reject) => {
        // 增加一个判断，如果没有actId，或者当前的actId为-1的话，则不再调用接口
        const _actId = actId || (state && state.actId) || '';
        if (!_actId || _actId.toString() === '-1') {
          return;
        }
        apiNoauthTenantConfig({actId: _actId}).then(res => {
          if (res.code === 200) {
            commit('SET_CALL_CENTER', res.data);
          } else {
            commit('SET_CALL_CENTER', false);
          }
        });
        getMdOpenFuncs({actId: _actId})
          .then(response => {
            if (response && response.code === 200) {
              commit('SET_OPEN_INFO', response.data || {});
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async GetUserPower({commit}, actId) {
      getPowerList({actId})
        .then(({
          code, data
        }) => {
          if (code === 200) {
            commit('SET_USER_POWER', data);
          }
        });
    },
    GetWSQZPower({
      commit, state
    }, actId) {
      // 增加兼容处理
      const id = actId || state.actId;
      if (!id) {
        return;
      }
      getAccountConfigByCond({actId: id})
        .then(({
          code, data
        }) => {
          if (code === 200) {
            commit('SET_WSQZ_POWER', data);
          }
        });
    },
    SetGrayTest({commit}) {
      function grayTest() {
        const grayTest = window.project_config.getConfig('grayTest') || [];
        const brtGrayTest = window.project_config.getConfig('brtGrayTest');
        commit('SET_GRAY_TEST', {grayTest, brtGrayTest});
      }

      if (window.project_config) {
        grayTest();
      } else {
        setTimeout(() => {
          grayTest();
        }, 500);
      }
    },
    async QueryUserActSignInfo({
      commit, state
    }) {
      // 增加兼容处理
      const id = state.actId;
      if (!id) {
        return;
      }
      await queryUserActSignInfo({actId: id})
        .then(({
          code, data
        }) => {
          if (code === 200) {
            commit('SET_USER_ACT_SIGN_INFO', data);
          }
        });
    },
    // 校验当前机构及所在机构树是否有调解员角色
    validMediatorFlagInActId({
      commit, state
    }) {
      if (!state.actId) {
        return;
      }
      validMetorFlaginActIds({actId: state.actId})
        .then(res => {
          if (res.code && res.code.toString() === '200') {
            commit('SET_VALID_MEDIATOR_FLAG', res.data || false);
          } else {
            commit('SET_VALID_MEDIATOR_FLAG', false);
          }
        })
        .catch(() => {
          commit('SET_VALID_MEDIATOR_FLAG', false);
        });
    },
    SaveMediationOrgans({commit}, actList) {
      commit('SET_MEDIATION_ORGANS', actList);
    }
  }
};
